import Header from './Header';
import Icon from '@/components/atoms/Icon';

interface FallbackProps {
  context: string;
  onClose: () => void;
}

export const AgenticChatErrorFallback = ({ context, onClose }: FallbackProps) => {
  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <div className="flex h-full flex-col p-4">
      <Header context={context} onClose={onClose} />
      <div className="flex h-full items-center justify-center p-4">
        <div className="max-w-md px-4 text-center">
          <div className="mb-4 text-red-600">
            <Icon name="IconAlertTriangle" className="mx-auto mb-2" size={48} />
            <h3 className="mb-2 text-lg font-semibold">Failed to Load Chat</h3>
            <p className="mb-4 text-sm text-gray-600">Make sure the agentic-chat service is running</p>
          </div>
          <button
            onClick={handleRetry}
            className="rounded-lg bg-blue-600 px-4 py-2 text-white transition-colors hover:bg-blue-700"
          >
            Retry
          </button>
        </div>
      </div>
    </div>
  );
};
